// Sync button text with WOD Preorder Now app
(function() {
  'use strict';
  
  function syncButtonText() {
    const forms = document.querySelectorAll('form[data-product-form].preorder-now-active');
    
    forms.forEach(form => {
      // Check if this form has a preorder note
      const preorderNote = form.querySelector('input#preorder-note[name="properties[Pre-Order]"]');
      
      if (preorderNote && preorderNote.value) {
        // Find the button in this form
        const button = form.querySelector('button[pre-order="pre-order-pom"][data-add-to-cart]');
        
        if (button) {
          const span = button.querySelector('[data-add-to-cart-text]');
          
          if (span) {
            // Update the span text with the preorder message
            span.textContent = preorderNote.value;
            
            // Also update the button value attribute
            button.value = preorderNote.value;
            
            // Update aria-label for accessibility
            button.setAttribute('aria-label', preorderNote.value);
          }
        }
      }
    });
  }
  
  // Sync on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtonText);
  } else {
    syncButtonText();
  }
  
  // Watch for changes in the DOM (when WOD app adds the preorder note)
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          if (node.id === 'preorder-note' || node.querySelector && node.querySelector('#preorder-note')) {
            syncButtonText();
          }
        }
      });
    });
  });
  
  // Observe the document for changes
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  // Initial sync after delays to let WOD app modify the DOM
  setTimeout(syncButtonText, 100);
  setTimeout(syncButtonText, 500);
  setTimeout(syncButtonText, 1000);
})();
